import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessengerService } from './messenger.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ConsentService implements OnDestroy
{
  public consentModels: Array<{ text: string; value: string }> = [
    { text: 'Network', value: 'NETWORK' },
    { text: 'Organizational', value: 'ORGANIZATIONAL' }
  ];

  private messagingLanguageChangedSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private messengerService: MessengerService)
  {
    this.loadLocalizations();
    this.messagingLanguageChangedSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.loadLocalizations();
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get the mood text to display.
   *
   * @param mood Mood value.
   */
  public getConsentModelDisplayText(consentType: string): string
  {
    let text = consentType;
    const consentObject = this.consentModels.find(x => x.value === consentType);
    if (consentObject !== undefined)
    {
      text = consentObject.text;
    }
    return text;
  }

  private loadLocalizations(): void
  {
    this.translate.get(['CONSENT-MODELS']).subscribe((res: string) =>
    {
      const splitted = res['CONSENT-MODELS'].split(',');
      for (let i = 0; i < splitted.length; i++)
      {
        if (this.consentModels.length > i)
        {
          this.consentModels[i].text = splitted[i];
        }
      }
    });
  }
}
